export default (
    <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5 0.500305C2.51562 0.500305 0.5 2.41874 0.5 4.78156C0.5 7.50031 3.5 11.8087 4.60156 13.2969C4.64729 13.3597 4.70722 13.4108 4.77646 13.446C4.84571 13.4813 4.9223 13.4997 5 13.4997C5.0777 13.4997 5.15429 13.4813 5.22354 13.446C5.29278 13.4108 5.35271 13.3597 5.39844 13.2969C6.5 11.8094 9.5 7.50249 9.5 4.78156C9.5 2.41874 7.48438 0.500305 5 0.500305Z"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5 6.50031C5.82843 6.50031 6.5 5.82873 6.5 5.00031C6.5 4.17188 5.82843 3.50031 5 3.50031C4.17157 3.50031 3.5 4.17188 3.5 5.00031C3.5 5.82873 4.17157 6.50031 5 6.50031Z"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
